import { render, staticRenderFns } from "./BottomBarAll.vue?vue&type=template&id=d6f1d396&"
import script from "./BottomBarAll.vue?vue&type=script&lang=js&"
export * from "./BottomBarAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports